export default {
  header: {
    title: { ru: 'Пример', en: 'Example' },
  },
}